import { render, staticRenderFns } from "./Storefront.vue?vue&type=template&id=8e027f6a"
import script from "./Storefront.vue?vue&type=script&lang=js"
export * from "./Storefront.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports